import React from "react";
import { motion } from "framer-motion";
import { easyonIndustries } from "../../data/easyonPageContent";
import { EasyonReveal } from "./EasyonMotion";

export const EasyonIndustryCarouselSection = () => (
    <section className="eo-industries">
        <div className="eo-container">
            <EasyonReveal className="eo-industries__head">
                <span className="eo-eyebrow eo-eyebrow--light">Industry Carousel</span>
                <h2 className="eo-h2 eo-h2--light">Built for Multi-Sector Operations</h2>
            </EasyonReveal>
            <div className="eo-industries__rail">
                <motion.div
                    className="eo-industries__track"
                    animate={{ x: ["0%", "-50%"] }}
                    transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
                >
                    {[...easyonIndustries, ...easyonIndustries].map((industry, i) => (
                        <div key={`${industry}-${i}`} className="eo-industries__item">{industry}</div>
                    ))}
                </motion.div>
            </div>
        </div>
    </section>
);
